<template>
  <div>
    <div class="i-layout-page-header">
      <div class="i-layout-page-header">
        <Button icon="ios-arrow-back" size="small" class="mr20" @click="$router.go(-1)">返回</Button>
        <span class="ivu-page-header-title mr20" v-text="$route.meta.title"></span>
      </div>
    </div>
    <Card :bordered="false" dis-hover class="ivu-mt">
      <Form ref="infoData" :model='infoData' label-position="right" :label-width="200"
            @submit.native.prevent>
        <Row :gutter="24" type="flex">

          <Col span="24">
            <FormItem label="静养圈编号" prop="pig_slaughter_rest_sn">
              <Input disabled="disabled" class="perW30" v-model="infoData.pig_slaughter_rest_sn"></Input>
            </FormItem>
          </Col>

          <Col span="24">
            <FormItem label="静养圈规模" prop="num">
              <Input disabled="disabled" class="perW30" v-model="infoData.num"></Input>
            </FormItem>
          </Col>

          <Col span="24">
            <FormItem label="静养圈位置" prop="location">
              <Input disabled="disabled" class="perW60" v-model="infoData.location"></Input>
            </FormItem>
          </Col>

        </Row>

      </Form>
    </card>

  </div>
</template>
<script>
import {pigSlaughterRestDetailApi} from '@/api/pigFarm/pigSlaughterRest'

export default {
  name: 'pigSlaughterRestInfo',
  data() {
    return {
      infoData: {
        pig_slaughter_rest_id: 0,
        pig_slaughter_rest_sn: '',
        num: '',
        location: '',
      },
    }
  },
  mounted() {
    if (this.$route.params.id !== '0' && this.$route.params.id) {
      this.loadInfoData(this.$route.params.id)
    }
  },
  methods: {

    // 编辑加载数据
    loadInfoData(id) {
      pigSlaughterRestDetailApi(id).then(res => {
        //数据赋值
        this.infoData = res.data

      }).catch(res => {
        this.$Message.error(res.msg)
      })
    },

  }
}
</script>
